import { Box } from "@chakra-ui/react";
import AllRoutes from "./Components/AllRoutes";


function App() {
  return (
    <Box bg={'#eeeeee'} >
      <AllRoutes />
    </Box>
  );
}

export default App;
